import gql from "graphql-tag";
import { useQuery } from "react-query";
import doRequest from "../utils/doRequest";

const getUnreads = gql`
  query GetUnreads {
    countUnreadNotifications {
      unreadMessages
      unreadNotifications
    }
  }
`;

export function useGetUnreads() {
  return useQuery(
    "getUnreads",
    async () => {
      return doRequest(
        {
          query: getUnreads,
        },
        "data.countUnreadNotifications"
      );
    },
    {
      retry: 1,
    }
  );
}
